import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-admin';
import { FieldProps } from '../../types';

/**
 * Component to display a partner field in the invoice list with a link to the partner's detail page
 * Uses the embedded partner object from the invoice API response
 */
const InvoicePartnerField: React.FC<FieldProps<any>> = ({
    record,
    link = 'show',
}) => {
    if (!record || !record.partner) return null;

    const { partner } = record;

    if (!partner.id || !partner.name)
        return <span>{partner.name || 'Unknown'}</span>;

    return link ? (
        <Link to={`/partners/${partner.id}/show`}>{partner.name}</Link>
    ) : (
        <span>{partner.name}</span>
    );
};

InvoicePartnerField.propTypes = {
    record: PropTypes.object,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    label: PropTypes.string,
};

InvoicePartnerField.defaultProps = {
    addLabel: true,
    label: 'Partner',
};

export default InvoicePartnerField;
